import React, { useEffect, useState } from "react";
import { I18nTranslator, translations } from "utils/i18n";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { GridColDef } from "@mui/x-data-grid";
import { usePaginationRequest } from "hooks/useRequest";
import { IGetAllLocationsReportRequest, IEmptyLocationsReport } from "model";
import { ReportApiService } from "services";
import { isEmpty } from "lodash";

interface ILocationListProps {
  request: IGetAllLocationsReportRequest;
}

const NewLocation = (props: ILocationListProps) => {
  const { request } = props;
  const [getAllLocationRequest, setGetAllLocationRequest] = useState({
    ...request,
    pageNumber: 1,
    pageSize: 100,
  });

  const { loading, result } = usePaginationRequest<
    IGetAllLocationsReportRequest,
    any[]
  >(getAllLocationRequest, ReportApiService.getAllProductLotReport);
  useEffect(() => {
    setGetAllLocationRequest({ ...getAllLocationRequest, ...request });
  }, [request]);

  const handleChangePage = (pageNumber: number) => {
    setGetAllLocationRequest({
      ...getAllLocationRequest,
      pageNumber: pageNumber,
    });
  };

  const _handlePageSizeChange = (pageSize: number) => {
    setGetAllLocationRequest({
      ...getAllLocationRequest,
      pageSize: pageSize,
    });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "productLot",
      headerName: I18nTranslator(translations.report.productLot),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.report.productCode),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productName",
      headerName: I18nTranslator(translations.report.productName),
      size: "medium",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productCodeOld",
      headerName: I18nTranslator(translations.report.productCodeOld),
      size: "small",
    }),
    TableHelper.createCell({
      field: "uom",
      headerName: I18nTranslator(translations.report.uom),
      size: "small",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "packSize",
      headerName: I18nTranslator(translations.report.packSize),
      size: "small",
      align: "right",
    }),
    TableHelper.createCell({
      field: "totalPallets",
      headerName: "Số lượng pallet",
      align: "right",
      size: "small",
    }),
    TableHelper.createCell({
      field: "totalCartons",
      headerName: I18nTranslator(translations.report.cartonQuantity),
      align: "right",
      size: "small",
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.report.quantity),
      align: "right",
      size: "small",
    }),
    TableHelper.createCell({
      field: "manufacturingDate",
      headerName: I18nTranslator(translations.report.manufacturingDate),
      size: "small",
    }),
    TableHelper.createCell({
      field: "expiryDate",
      headerName: I18nTranslator(translations.report.expiryDate),
      size: "small",
    }),
  ];
  return (
    <AppTable<IEmptyLocationsReport>
      loading={loading}
      data={{
        ...result,
      }}
      columns={COLUMNS}
      actionColumnProps={{
        hideEdit: true,
      }}
      onSearch={(searchValue: string) => {}}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchReceiveDocument
      )}
      onChangePage={handleChangePage}
      hideHeader
      hideSearch
      removeActionColumn
      defaultHeaderTable={280}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default NewLocation;
